import {
    CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE,
    CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES,
    CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_BADGE_DETAIL,
    CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE,
    CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES,
    CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES,
    CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_PAST_CHALLENGES,
    CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE,
    CHALLENGE_PAGE_INIT,
    CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE,
    CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE,
    CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE,
    CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE,
    CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE,
    CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE_DONE,
    CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE,
    CHALLENGE_PAGE_RESET,
    CHALLENGE_PAGE_SET_BADGE_CHALLENGE_NOTIFICATION_STATUS,
    CHALLENGE_PAGE_SET_BADGE_DETAIL_DIALOG_OPEN,
    CHALLENGE_PAGE_SET_OPT_OUT_DIALOG,
    CHALLENGE_PAGE_SET_ROUTE,
    CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE,
    CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT,
    CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE,
    CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE,
    CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK,
    CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE,
    CHALLENGE_PAGE_PRE_JOIN_CONFIRM_DIALOG_ACTION,
    CHALLENGE_PAGE_PREPARE_JOIN_CHALLENGE
} from './ActionTypes';

export const challengePageInit = ({ viewerSocialProfile, route }) => ({
    type: CHALLENGE_PAGE_INIT,
    viewerSocialProfile,
    route
});

export const challengePageReset = () => ({
    type: CHALLENGE_PAGE_RESET
});

export const challengePageSetRoute = ({ route }) => ({
    type: CHALLENGE_PAGE_SET_ROUTE,
    route
});

/**
 * fetch available badge challenges
 * @param {{
 *  limit: number;
 *  categoryTypeIds: number[]
 *  showExclusive?: boolean;
 * }} payload
 * @returns
 */
export const challengePageFetchAvailableBadgeChallenges = ({ limit = 0, categoryTypeIds = [], showExclusive }) => ({
    type: CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES,
    limit,
    categoryTypeIds,
    showExclusive
});

export const challengePageFetchAvailableBadgeChallengesDone = ({ error = false, list = null, hasMore = false }) => ({
    type: CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE,
    error,
    list,
    hasMore
});

/**
 * update badge challenge in available list, like `userJoined`
 * @param {*} challenge
 * @returns
 */
export const challengePageUpdateAvailableBadgeChallenge = (challenge) => ({
    type: CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE,
    challenge
});

export const challengePageJoinBadgeChallenge = (challenge) => ({
    type: CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE,
    challenge
});

export const challengePageJoinBadgeChallengeDone = ({ error, challenge }) => ({
    type: CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE,
    error,
    challenge
});

export const challengePageUndoJoinBadgeChallenge = () => ({
    type: CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE
});

export const challengePageSetBadgeChallengeNotificationStatus = (notificationStatus) => ({
    type: CHALLENGE_PAGE_SET_BADGE_CHALLENGE_NOTIFICATION_STATUS,
    notificationStatus
});

/**
 * fetch virtual challenges
 * @param {{
 *  limit: number;
 *  categoryTypeIds: number[]
 * }} payload
 * @returns
 */
export const challengePageFetchVirtualChallenges = ({ limit = 0, categoryTypeIds = [] }) => ({
    type: CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES,
    limit,
    categoryTypeIds
});

export const challengePageFetchVirtualChallengesDone = ({ error = false, list = null, hasMore = false }) => ({
    type: CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE,
    error,
    list,
    hasMore
});

export const challengePageVirtualChallengeDetailInit = ({ challengeUuid }) => ({
    type: CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT,
    challengeUuid
});

export const challengePageVirtualChallengeDetailInitDone = ({ error = false, challenge = null }) => ({
    type: CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE,
    error,
    challenge
});

export const challengePageSetBadgeDetailDialogOpen = ({ open }) => ({
    type: CHALLENGE_PAGE_SET_BADGE_DETAIL_DIALOG_OPEN,
    open
});

export const challengePageFetchBadgeDetail = () => ({
    type: CHALLENGE_PAGE_FETCH_BADGE_DETAIL
});

export const challengePageFetchBadgeDetailDone = ({ error = false, badge }) => ({
    type: CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE,
    error,
    badge
});

export const challengePageOptInVirtualChallenge = () => ({
    type: CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE
});

export const challengePageOptInVirtualChallengeDone = ({ error = false, tooMany = false }) => ({
    type: CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE,
    error,
    tooMany
});

export const challengePageOptInVirtualChallengeErrorAck = () => ({
    type: CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK
});

export const challengePageOptOutVirtualChallenge = () => ({
    type: CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE
});

export const challengePageOptOutVirtualChallengeDone = (error = false) => ({
    type: CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE_DONE,
    error
});

/**
 *
 * @param {{
 *  limit?: number;
 *  showExclusive?: boolean;
 * }} payload
 * @returns
 */
export const challengePageFetchCurrentChallenges = ({ limit = 0, showExclusive }) => ({
    type: CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES,
    limit,
    showExclusive
});

export const challengePageFetchCurrentChallengesDone = ({
    error = false,
    autoChallenge = null,
    groupChallenges = null,
    adHocChallenges = null,
    vivokidChallenges = null,
    teamStepsVivokidChallenges = null,
    badgeChallenges = null,
    virtualChallenges = null
}) => ({
    type: CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE,
    error,
    autoChallenge,
    groupChallenges,
    adHocChallenges,
    vivokidChallenges,
    teamStepsVivokidChallenges,
    badgeChallenges,
    virtualChallenges
});

export const challengePageOptOutAutoChallenge = () => ({
    type: CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE
});

export const challengePageSetOptOutDialog = ({ open = false, submitting = false }) => ({
    type: CHALLENGE_PAGE_SET_OPT_OUT_DIALOG,
    open,
    submitting
});

export const challengePageFetchAutoChallengeDone = ({ error = false, autoChallenge = null }) => ({
    type: CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE,
    error,
    autoChallenge
});

/**
 *
 * @param {{
 *  limit?: number;
 *  showExclusive?: boolean;
 * }} payload
 * @returns
 */
export const challengePageFetchPastChallenges = ({ limit = 0, showExclusive = false }) => ({
    type: CHALLENGE_PAGE_FETCH_PAST_CHALLENGES,
    limit,
    showExclusive
});

export const challengePageFetchPastChallengesDone = ({
    error = false,
    autoChallenge = null,
    groupChallenges = null,
    adHocChallenges = null,
    vivokidChallenges = null,
    teamStepsVivokidChallenges = null,
    badgeChallenges = null,
    virtualChallenges = null
}) => ({
    type: CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE,
    error,
    autoChallenge,
    groupChallenges,
    adHocChallenges,
    vivokidChallenges,
    teamStepsVivokidChallenges,
    badgeChallenges,
    virtualChallenges
});

/**
 *
 * @param {Object} payload
 * @param {boolean} payload.open
 * @param {boolean} [payload.submitting]
 * @param {number | null} [payload.dialogType]
 * @param {Object | null} payload.challenge
 * @param {number[]} payload.confirmed
 * @param {boolean} [payload.hasSubscribed]
 * @returns
 */
export const challengePageSetPreJoinConfirmDialogState = ({
    open,
    submitting,
    dialogType,
    challenge,
    confirmed = [],
    hasSubscribed
}) => {
    return {
        type: CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE,
        open,
        submitting,
        dialogType,
        challenge,
        confirmed,
        hasSubscribed
    };
};

/**
 * when user click on confirm action (like join), `confirm` is `true`; else `false`
 * @param {boolean} confirm
 * @returns
 */
export const challengePagePreJoinConfirmDialogAction = (confirm) => {
    return {
        type: CHALLENGE_PAGE_PRE_JOIN_CONFIRM_DIALOG_ACTION,
        confirm
    };
};

export const challengePagePrepareJoinChallenge = ({ challenge, hasSubscribed }) => {
    return {
        type: CHALLENGE_PAGE_PREPARE_JOIN_CHALLENGE,
        challenge,
        hasSubscribed
    };
};
